module.exports = __webpack_public_path__ + "static/img/formImg.eccc6d84.png";